<template>
  <v-container>
    <v-row>
      <v-col cols="12" lg="12" xl="3" class="text-center text-xl-left">
        <v-btn fab :color="value.color" :dark="isButtonDark">
          <v-icon>{{value.icon}}</v-icon>
        </v-btn>
      </v-col>
      <v-col cols="12" lg="12" xl="9" class="text-center text-xl-left">
        <h3 class>{{value.title}}</h3>
        <span class="mt-2 text-h1">{{value.description}}</span>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "PagePreviewTile",
  props: ["value"],
  computed: {
    isButtonDark() {
      return this.$helpers.lightOrDark(this.value.color) === "dark";
    }
  }
};
</script>

<style>
</style>